import React from "react";
import { useNavigate } from "react-router-dom";
import "./Story.css";
import "./contentpage.css";

function ForewordContemporaryInstitutes() {
  const navigate = useNavigate();

  const handleBegin = () => {
    navigate("/contemporaryfinance-51"); //
  };
  return (
    <div className="story-page">
      <div className="story-container">
        بسم الله الرحمن الرحيم
        <h1 className="story-title">Curators Foreword</h1>
        <h3>Review of Contemporary Financial Systems</h3>
        <p className="story-text">
          <p className="story-text">
            Most people alive today have never lived under a gold or silver
            standard. Instead, we were born into an era dominated by fiat money.
            As a result, the existing monetary system often feels natural,
            familiar, and unquestioned.
            <br />
            <br />
            This section examines the evolution of fiat money, including the
            emergence of banks, the development of fractional reserve banking,
            and the rise of paper currency as it exists today. By tracing how
            modern financial institutions came into being, the learner is
            encouraged to critically analyze the structural foundations of the
            current monetary ecosystem.
            <br />
            <br />
            Only through a careful and honest examination of the flaws inherent
            within contemporary monetary systems can one truly appreciate the
            need for an alternative. This critical understanding lays the
            groundwork for recognizing why a new and superior monetary network,
            namely Bitcoin, has emerged in response to these systemic
            shortcomings.
            <br />
            <br />
            Each lesson includes a dashboard with a timer, a summary paragraph,
            and four MCQs to test understanding.
            <br />
            <br />
            The ideal pace is one lesson per day, though learners may adjust
            according to their capacity.{" "}
          </p>
        </p>
        {/* BUTTON */}
        <button className="popup-close-btn" onClick={handleBegin}>
          Let us begin!
        </button>
      </div>
    </div>
  );
}

export default ForewordContemporaryInstitutes;
